exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-styler .product-options .vue-color__chrome {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n}\n.list-styler .product-options > .option > .bootstrap-switch {\n  right: 0;\n  position: absolute;\n  top: 5px;\n}\n.list-styler .ui-spinner {\n  width: 100%;\n}\n.list-styler .ui-spinner > #font-size {\n  font-size: 16px !important;\n  width: 100%;\n  color: #333;\n}\n.list-styler .ui-spinner.focus > #font-size {\n  color: #16a085;\n}\n", ""]);

// exports
